// NESW Theme JS

(function() {
  'use strict';

  // Ensure basic Shopify compatibility
  window.NESW = window.NESW || {};

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Theme initialized
  }

})();
